<mat-card>
  <mat-card-header>
    <mat-card-title
      cdkDrag
      cdkDragHandle
      cdkDragRootElement=".cdk-overlay-pane"
    >
      {{ title }}
    </mat-card-title>
  </mat-card-header>

  <!-- Form -->
  <mat-card-content style="margin: 2em 0; max-height: 65vh; overflow: auto">
    @if (formulario) {
      <form
        id="form"
        [formGroup]="formulario"
        (ngSubmit)="enviar()"
        autocomplete="off"
      >
        <!-- MAC Control -->
        <mat-form-field>
          <mat-label>MAC</mat-label>
          <input
            [tabIndex]="-1"
            matInput
            placeholder="MAC del control"
            formControlName="mac"
            required
          />
        </mat-form-field>
        <!-- Etiqueta -->
        <mat-form-field>
          <mat-label>Etiqueta</mat-label>
          <input
            matInput
            placeholder="Etiqueta del control"
            formControlName="etiqueta"
          />
        </mat-form-field>
        <mat-checkbox
          formControlName="incrementar"
          style="margin-bottom: 2em"
          [tabIndex]="-1"
        >
          Incrementar etiqueta automaticamente
        </mat-checkbox>
        <!-- Cliente para filtrar vecinos -->
        <mat-form-field>
          <mat-label>Cliente</mat-label>
          <mat-select formControlName="idCliente">
            @for (dato of clientes; track dato) {
              <mat-option [value]="dato._id">{{ dato.nombre }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <!-- Configs -->
        <ng-select
          [items]="(configs$ | async) ?? []"
          [typeahead]="inputConfigs$"
          [loading]="loading"
          [minTermLength]="3"
          bindLabel="datosPersonales.nombre"
          bindValue="_id"
          formControlName="idConfigVecino"
          loadingText="Cargando..."
          typeToSearchText="Buscar por DNI o Nombre"
          notFoundText="No se encontraron vecinos"
          appendTo=".cdk-overlay-popover"
          [placeholder]="'Vecino'"
        >
          <ng-template
            ng-option-tmp
            let-item="item"
            let-item$="item$"
            let-index="index"
          >
            <span>{{ item.datosPersonales?.nombre }} </span>
            <span style="font-size: 1em">
              ({{ item.datosPersonales?.dni }})</span
            >
            <span style="font-size: 1em"> ({{ item.cliente?.nombre }})</span>
          </ng-template>
          <ng-template
            ng-label-tmp
            let-item="item"
            let-item$="item$"
            let-index="index"
          >
            <span>{{ item.datosPersonales?.nombre }} </span>
            <span style="font-size: 1em">
              ({{ item.datosPersonales?.dni }})</span
            >
            <span style="font-size: 1em"> ({{ item.cliente?.nombre }})</span>
          </ng-template>
        </ng-select>
      </form>
    }
  </mat-card-content>

  <mat-divider />

  <!-- Botones -->
  <mat-card-actions class="gap-3" style="margin: 0.5em">
    <button
      class="botonSpinner"
      mat-raised-button
      color="primary"
      type="submit"
      [disabled]="!formulario?.valid || loading"
      form="form"
    >
      <div
        class="loadSpinnerButton"
        [style.display]="loading ? 'flex' : 'none'"
      >
        <mat-spinner
          class="mx-2"
          [diameter]="25"
          mode="indeterminate"
          color="warn"
        />
      </div>
      <span [style.display]="loading ? 'none' : 'block'">Guardar</span>
    </button>

    <button mat-raised-button type="button" (click)="close()" [tabIndex]="-1">
      Volver
    </button>
  </mat-card-actions>

  <!-- Progress Bar  -->
  <mat-card-footer>
    <mat-progress-bar [mode]="loading ? 'indeterminate' : 'determinate'" />
  </mat-card-footer>
</mat-card>
